import { render, staticRenderFns } from "./NoPlanPage.vue?vue&type=template&id=51037be3&"
import script from "./NoPlanPage.vue?vue&type=script&lang=ts&"
export * from "./NoPlanPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports